/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

export class QoEConnectionModeType {
    static AWAY = 'Away';

    static LOCAL = 'Local';

    static OFFLINE = 'Offline';

    static UNKNOWN = 'Unknown'; // default state
}
